import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#25252D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3.75 15.667V8.333A4.583 4.583 0 0 1 8.333 3.75h7.334a4.584 4.584 0 0 1 4.583 4.583v7.334a4.584 4.584 0 0 1-4.583 4.583H8.333a4.583 4.583 0 0 1-4.583-4.583"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#25252D",
  stroke: "#25252D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.854 8.854a.5.5 0 1 1-.706-.708.5.5 0 0 1 .706.708"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#25252D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M14.145 20.25q.099-.653.105-1.314A9.186 9.186 0 0 0 5.063 9.75q-.66.005-1.313.105"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }